import { Avatar, NotificationBadge, Spinner } from '@bphxd/ds-core-react'
import { UncontrolledDropdown, DropdownMenu, DropdownItem, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './MainHeader.scss'
import axios from "axios";
import { LogOut24 } from '@bphxd/ds-core-react/lib/icons'
import { IPublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useUser } from '../../contexts/userContextApi';
import Notification from './Notification';
//import { getNotifications } from '../../api/endpoints';

export default function MainHeader() {
  const [userName, setUserName] = useState<any>('User');
  const { isAuthorize, isLoadingLandingPage, role } = useUser();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  //const isAdmin = sessionStorage.getItem("isAdmin");
  //let auth = sessionStorage.getItem("isUnAuth");
  const tokenExpireTime = sessionStorage.getItem("tokenExpireTime");
  const toMilliseconds = (hrs: any, min: number, sec: number) => (hrs * 60 * 60 + min * 60 + sec) * 1000;
  //const tokenExpTime = toMilliseconds(0, parseInt(tokenExpireTime ? tokenExpireTime : "0"), 0);
  const tokenExpTime = 60 * 60 * 1000;
  const [sessionExpiry, setSessionExpiry] = useState(Number(sessionStorage.getItem("sessionExpiry")));//added by Gowthami 8 lines
  useEffect(() => {
    if (!isAuthenticated) return;

    const expiry = Date.now() + tokenExpTime;

    sessionStorage.setItem("sessionExpiry", expiry.toString());
    setSessionExpiry(expiry);
    setTimeLeft(Math.floor(tokenExpTime / 1000));
  }, [isAuthenticated]);
  const counters = sessionStorage.getItem("noiticationcount") || "0";
  const [timeLeft, setTimeLeft] = useState(60 * 60);
  const [showWarning, setShowWarning] = useState(false);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [unreadOffSet, setUnreadOffSet] = useState<number>(0);
  const [archivedOffSet, setArchivedOffSet] = useState<number>(0);

  const [fileNotifications, setFileNotifications] = useState([])

  // TODO: TESTING ONLY — remove before production
  // const dummyNotifications = [
  //   { notification_id: 1,  notification_message: "Your DRN document for order ORD-1001 has been successfully processed.", url: "", is_read: false, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-28T09:00:00"), source_name: "DRN Service", usertype: "bp_user", order_number: "ORD-1001" },
  //   { notification_id: 2,  notification_message: "Invoice INV-2002 upload failed due to a validation error.", url: "", is_read: false, notification_type: "FAILURE", email: "test@castrol.com", timestamp: new Date("2026-07-28T09:15:00"), source_name: "Invoice Service", usertype: "bp_user", order_number: "ORD-1002" },
  //   { notification_id: 3,  notification_message: "Annual certificate for order ORD-1003 is ready for download.", url: "https://example.com/doc3", is_read: false, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-28T10:00:00"), source_name: "Certificate Service", usertype: "bp_user", order_number: "ORD-1003" },
  //   { notification_id: 4,  notification_message: "DRN upload for order ORD-1004 is pending approval.", url: "", is_read: false, notification_type: "FAILURE", email: "test@castrol.com", timestamp: new Date("2026-07-28T10:30:00"), source_name: "DRN Service", usertype: "bp_user", order_number: "ORD-1004" },
  //   { notification_id: 5,  notification_message: "Tax certificate for ORD-1005 has been generated successfully.", url: "https://example.com/doc5", is_read: false, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-28T11:00:00"), source_name: "Tax Service", usertype: "bp_user", order_number: "ORD-1005" },
  //   { notification_id: 6,  notification_message: "Order ORD-1006 document upload failed. Please retry.", url: "", is_read: false, notification_type: "FAILURE", email: "test@castrol.com", timestamp: new Date("2026-07-28T11:30:00"), source_name: "Upload Service", usertype: "bp_user", order_number: "ORD-1006" },
  //   { notification_id: 7,  notification_message: "DRN for order ORD-2001 was processed successfully.", url: "https://example.com/doc7", is_read: true, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-27T08:00:00"), source_name: "DRN Service", usertype: "bp_user", order_number: "ORD-2001" },
  //   { notification_id: 8,  notification_message: "Invoice INV-2002 has been archived after successful verification.", url: "", is_read: true, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-27T09:00:00"), source_name: "Invoice Service", usertype: "bp_user", order_number: "ORD-2002" },
  //   { notification_id: 9,  notification_message: "Annual certificate ORD-2003 upload was rejected.", url: "", is_read: true, notification_type: "FAILURE", email: "test@castrol.com", timestamp: new Date("2026-07-27T09:30:00"), source_name: "Certificate Service", usertype: "bp_user", order_number: "ORD-2003" },
  //   { notification_id: 10, notification_message: "Tax certificate for ORD-2004 archived successfully.", url: "https://example.com/doc10", is_read: true, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-27T10:00:00"), source_name: "Tax Service", usertype: "bp_user", order_number: "ORD-2004" },
  //   { notification_id: 11, notification_message: "Document for order ORD-2005 was deleted by admin.", url: "", is_read: true, notification_type: "FAILURE", email: "test@castrol.com", timestamp: new Date("2026-07-27T10:30:00"), source_name: "Admin Service", usertype: "bp_user", order_number: "ORD-2005" },
  //   { notification_id: 12, notification_message: "DRN ORD-2006 archived after 30-day retention period.", url: "", is_read: true, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-27T11:00:00"), source_name: "DRN Service", usertype: "bp_user", order_number: "ORD-2006" },
  //   { notification_id: 13, notification_message: "Upload for order ORD-2007 completed and archived.", url: "https://example.com/doc13", is_read: true, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-27T11:30:00"), source_name: "Upload Service", usertype: "bp_user", order_number: "ORD-2007" },
  //   { notification_id: 14, notification_message: "Certificate for ORD-2008 archived — no action required.", url: "", is_read: true, notification_type: "SUCCESS", email: "test@castrol.com", timestamp: new Date("2026-07-27T12:00:00"), source_name: "Certificate Service", usertype: "bp_user", order_number: "ORD-2008" },
  // ];
  // const [fileNotifications, setFileNotifications] = useState<any[]>(dummyNotifications)
  const jwtToken = sessionStorage.getItem('jwt');

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  useEffect(() => {
    const remaining = sessionExpiry - Date.now();
    if (remaining > 0) {
      const timer = setTimeout(() => {
        setShowWarning(false);
        sessionStorage.clear();
        redirectSignOut(instance);
      }, remaining);
      return () => clearTimeout(timer);
    }
  }, [sessionExpiry]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    const interval = setInterval(() => {
      const remaining = Math.max(
        0,
        Math.floor((sessionExpiry - Date.now()) / 1000)
      );

      setTimeLeft(remaining);

      if (remaining === 60) {
        setShowWarning(true);
      }

      if (remaining <= 0) {
        clearInterval(interval);
        setShowWarning(false);
        sessionStorage.clear();
        redirectSignOut(instance);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isAuthenticated, instance, sessionExpiry]);


  // useEffect(()=>{
  //     let email=''
  //     let userType=''
  //     const loginSource = sessionStorage.getItem('role');
  //     if(isAuthenticated){
  //         email = accounts[0].username
  //         userType='bp_user'
  //     } else if(loginSource === 'vendor'){
  //         email = sessionStorage.getItem('vendorUsername')||''
  //         userType='vendor'
  //     }
  //     const activeTab = sessionStorage.getItem("activeTab")
  //     const is_read = ( unreadOffSet === 0 && archivedOffSet === 0 ) ? 'initial' : (activeTab === 'archived' ? 'true' : "false");
  //     console.log(email,jwtToken, 'email inside useeffect notgiig')
  //     if(email !== '' && email !== null && jwtToken){
  //         console.log(isAuthorize, 'isAuthorize inside useeffect notgiig')
  //         fetchNotifications(email, userType, activeTab === 'archived' ? archivedOffSet : unreadOffSet, is_read)
  //         .then((data) => {
  //             setFileNotifications((prev) => {
  //                 if( unreadOffSet > 0 || archivedOffSet > 0){
  //                     return [...prev, ...data.notifications]
  //                 } else {
  //                     return data.notifications
  //                 }
  //                 })
  //             setUnreadNotificationsCount(data.unread);
  //         }).catch(err => console.log(err))
  //     }
  // }, [isAuthenticated, isAuthorize, jwtToken, unreadOffSet, archivedOffSet,userName])

  // const fetchNotifications = async (email: any, userType: String, offSet: Number, is_read: String) => {
  //     const token = jwtToken;
  //     console.log('token before notif call', token)
  //     const encodedEmail = encodeURIComponent(email)
  //     const response = await axios.get(`${getNotifications}?email=${encodedEmail}&userType=${userType}&offset=${offSet}&is_read=${is_read}`
  //         ,{
  //         headers: {
  //             'x-api-key':"gmedocumenthubtest.castrol.com",
  //             'Content-Type': 'application/json',
  //               Authorizationtoken: `Bearer ${token}`
  //     }}
  //     );
  //     if(response.data.statusCode === 200){
  //         return response.data.body;
  //     } else if(response.data.statusCode === 404){
  //         throw new Error('no new data to load')
  //     } else {
  //         return {
  //             notifications : [],
  //             unread: 0
  //         }
  //     }   
  // };

  useEffect(() => {
    if (isAuthenticated) {
      if (accounts[0].idTokenClaims?.name?.length !== 0 || accounts[0].idTokenClaims?.name !== undefined) {
        setUserName(accounts[0].idTokenClaims?.name);
      }
    }
    else {
      setUserName('User');
    }
  }, [isAuthenticated, accounts]);

  const redirectSignOut = (instance: IPublicClientApplication) => {
    const logoutRequest = {
      postLogoutRedirectUri: window.location.origin,
    };
    localStorage.removeItem("loginCaller"); // Clear loginCaller from localStorage
    sessionStorage.clear();
    instance.logoutRedirect(logoutRequest);
  };
  return (
    <div>
      <div style={{ display: 'block' }} className=''>
        <div className='main-header-logo-background main-header-logo'>
          <img
            className='main-header-logo-img'
            width="100%"
            height="100%"
            src='/images/castrol_logo.svg'
            alt='Castrol Logo'
          />
          <div className='main-header-text'>IT'S MORE THAN JUST OIL. IT'S LIQUID ENGINEERING</div>


          {isAuthorize &&
            <AuthenticatedTemplate>
              <UncontrolledDropdown className="d-inline-flex ms-6 profile-field">

                {sessionStorage.getItem("isUnAuth") === "true" && (
                  <>
                    {(role === 'tax_user') && <Notification />}

                    {isAuthenticated && (
                      <div
                        style={{
                          // position: "fixed",
                          // top: "20px",
                          // right: "180px",
                          zIndex: 99999,
                          alignItems: "center",
                          color: "#ff0000",
                          fontWeight: "bold",
                          fontSize: "13px",
                          background: "transparent",
                          padding: "4px 16px",
                          borderRadius: "4px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Your current session will expire within:{" "}
                        {Math.floor(timeLeft / 60)}:
                        {String(timeLeft % 60).padStart(2, "0")} minute
                      </div>
                    )}
                  </>
                )}

                <Avatar size='sm' className="me-3" label="My Account" suffix dropdown />

                <DropdownMenu end>

                  <DropdownItem disabled>
                    <span>Welcome{' '}{userName}</span>
                  </DropdownItem>
                  <DropdownItem disabled>
                    <span>Logged in as {role === "admin" ? "Admin" : role === "super_user" ? "Super User" : role === "itr_user" ? "Itr User" : role === "tax_user" ? "Tax User" : role === "vendor" ? "Vendor" : "User"}</span>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={() => redirectSignOut(instance)}>
                    <span><LogOut24 className='mx-3' color='#007f00' />Sign Out</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </AuthenticatedTemplate>
          }
        </div>
      </div>
      {
        isLoadingLandingPage && (
          <div className="landing-loader">
            <Spinner color="brand" />
          </div>
        )
      }
      <Modal isOpen={showWarning} centered>
        <ModalHeader>Session Expiry Warning</ModalHeader>

        <ModalBody>Your session will expire in 1 minute.
          <br />
          Would you like to continue your session?
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              setShowWarning(false);

              const newExpiry = Date.now() + tokenExpTime;

              sessionStorage.setItem("sessionExpiry", newExpiry.toString());
              setSessionExpiry(newExpiry);

              setTimeLeft(Math.floor(tokenExpTime / 1000));
            }}
          >
            Continue Session
          </Button>

          <Button
            color="primary"
            onClick={() => {
              setShowWarning(false);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}